import connect from 'react-redux/es/connect/connect';

import Licensing from '../components/Licensing';

const mapStateToProps = (state, { licensing, classes, ...restOwnProps }) => {
    return {
        ...restOwnProps,
        options: licensing,
        userClasses: classes || [],
        securityClasses: state.userDetails.security || [],
    };
};

const mapDispatchToProps = dispatch => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Licensing);